import { render, staticRenderFns } from "./Brivo.vue?vue&type=template&id=68200875&scoped=true&"
import script from "./Brivo.vue?vue&type=script&lang=js&"
export * from "./Brivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68200875",
  null
  
)

export default component.exports